import React, {FC, useState, useCallback} from "react";
import {Box, InputAdornment, TextField} from "@mui/material";
import {makeStyles} from "tss-react/mui";
import SendIcon from "@mui/icons-material/Send";

const useStyles = makeStyles()((theme) => ({
	commentInput: {
		marginTop: "10px",
		display: "flex",
		flexDirection: "column",
		gap: "8px"
	},
	input: {
		width: "100%",
		border: "1px solid #d8d8d8",
		borderRadius: "6px",
		padding: "10px 16px",
		boxSizing: "border-box",
		backgroundColor: "transparent",
		"& .MuiInputBase-input": {
			backgroundColor: "transparent"
		}
	},
	icon: {
		cursor: "pointer"
	},
	endAdornment: {
		display: "flex",
		gap: "8px",
		marginBottom: "12px",
		alignSelf: "end"
	}
}));

export interface CommentInputProps {
	postComment: (content: string, threadOf?: number) => void;
	placeholder?: string;
	threadOf?: number;
	className?: string;
}

export const CommentInput: FC<CommentInputProps> = ({
	postComment,
	placeholder = "Leave a comment",
	threadOf,
	className
}) => {
	const {classes, cx} = useStyles();
	const [comment, setComment] = useState("");

	const handleSubmit = useCallback(() => {
		if (!comment.trim()) return;
		postComment(comment.trim(), threadOf);
		setComment("");
	}, [comment, postComment, threadOf]);

	return (
		<Box className={cx(classes.commentInput, className)}>
			<TextField
				className={classes.input}
				variant="standard"
				placeholder={placeholder}
				multiline
				InputProps={{
					disableUnderline: true,
					autoCapitalize: "none",
					autoComplete: "off",
					endAdornment: (
						<InputAdornment className={classes.endAdornment} position="end">
							<SendIcon
								className={classes.icon}
								data-test-id="comment-input-send-btn"
								onClick={handleSubmit}
							/>
						</InputAdornment>
					)
				}}
				onChange={(e) => setComment(e.target.value)}
				value={comment}
			/>
		</Box>
	);
};
